import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistStore } from 'redux-persist';
import authReducer from './Features/authslice';
import { EndPointsApis } from './services/EndPointsApis';
import { commonReducer } from '../src/Features/commonSlice';

const rootReducer = combineReducers({
  common: commonReducer,
  auth: authReducer,
  [EndPointsApis.reducerPath]: EndPointsApis.reducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(EndPointsApis.middleware),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

export const persistor = persistStore(store);
